import { Routes, Route, Navigate } from "react-router-dom";
import DashboardAdmin from "./pages/admin/DashboardAdmin";
import DashboardTrabajador from "./pages/trabajador/DashBoardTrabajador";
import DashboardGlobalAdmin from "./pages/globalAdmin/DashboardGlobalAdmin";
import Login from "./pages/public/Login";
import ForgotPassword from "./pages/public/ForgotPassword";
import ResetPassword from "./pages/public/ResetPassword";
import PoliticaPrivacidad from "./pages/public/PoliticaPrivacidad";
import ProtectedRoute from "./components/common/ProtectedRoute";
import EmpresaDetail from "./pages/admin/EmpresaDetail";
import UserSection from "./components/admin/UserSection";
import EmpresasSection from "./components/admin/EmpresasSection";
import CookieBanner from "./components/common/CookieBanner";
import { useContext } from "react";
import { AuthContext } from "./context/AuthContext";

export default function App() {
  const { user } = useContext(AuthContext);

  return (
    <>
      <CookieBanner />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="/politica-privacidad" element={<PoliticaPrivacidad />} />

      {/* Raíz redirige según rol */}
      <Route
        path="/"
        element={
          !user ? (
            <Navigate to="/login" />
          ) : user.role === "trabajador" ? (
            <Navigate to="/trabajador" />
          ) : user.role === "admin" ? (
            <Navigate to="/admin" />
          ) : user.role === "global_admin" ? (
            <Navigate to="/global-admin" />
          ) : (
            <Navigate to="/login" />
          )
        }
      />

      {/* Página intermedia para admins de empresa */}

      <Route
        path="/empresas/:id"
        element={
          <ProtectedRoute roles={["global_admin"]}>
            <EmpresaDetail />
          </ProtectedRoute>
        }
      />

      <Route
        path="/global-admin"
        element={
          <ProtectedRoute roles={["global_admin"]}>
            <DashboardGlobalAdmin />
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin"
        element={
          <ProtectedRoute roles={["admin"]}>
            <DashboardAdmin />
          </ProtectedRoute>
        }
      />

      <Route
        path="/trabajador"
        element={
          <ProtectedRoute roles={["trabajador", "admin", "global_admin"]}>
            <DashboardTrabajador />
          </ProtectedRoute>
        }
      />

      {/* Fichajes (para admins) - Renderiza el dashboard completo */}
      <Route
        path="/fichajes"
        element={
          <ProtectedRoute roles={["admin", "global_admin"]}>
            <DashboardAdmin />
          </ProtectedRoute>
        }
      />

      {/* Fichajes filtrados por usuario - Renderiza el dashboard completo */}
      <Route
        path="/fichajes/:userId"
        element={
          <ProtectedRoute roles={["admin", "global_admin"]}>
            <DashboardAdmin />
          </ProtectedRoute>
        }
      />

      {/* Usuarios (para admins) */}
      <Route
        path="/usuarios"
        element={
          <ProtectedRoute roles={["admin", "global_admin"]}>
            <UserSection />
          </ProtectedRoute>
        }
      />

      {/* Empresas (solo admin global) */}
      <Route
        path="/empresas"
        element={
          <ProtectedRoute roles={["global_admin"]}>
            <EmpresasSection />
          </ProtectedRoute>
        }
      />

      <Route path="*" element={<Login />} />
      </Routes>
    </>
  );
}
